import { render, staticRenderFns } from "./IconComponentWA2hs.vue?vue&type=template&id=76698935&"
import script from "./IconComponentWA2hs.vue?vue&type=script&lang=js&"
export * from "./IconComponentWA2hs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports